import {SummaryReport} from '@/types/reports/Report'

export class BalanceReport extends SummaryReport {
}